import { useMemo, useState } from "react";
import { formatearNumeros } from "../../../utils/formatters";
import type { ClienteRuta } from "../VerDetallesRutasModal/types";
import type {
  UseVerTablaClientesModalReturn,
  VerTablaClientesModalProps,
} from "./types";
const emptyClientes: ClienteRuta[] = [];

const normalizarNumero = (value: number | string | null | undefined): number => {
  const parsedValue = Number(value ?? 0);

  return Number.isNaN(parsedValue) ? 0 : parsedValue;
};

export const useVerTablaClientesModal = ({
  clientes,
  setVerClientes,
}: VerTablaClientesModalProps): UseVerTablaClientesModalReturn => {
  const [isModalCreateClienteExistente, setIsModalCreateClienteExistente] =
    useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermExis, setSearchTermExis] = useState("");
  const clientesData = clientes ?? emptyClientes;

  const sumaPagosDiarios = useMemo(
    () =>
      clientesData.reduce(
        (total, cliente) => total + normalizarNumero(cliente.pagoDiario),
        0
      ),
    [clientesData]
  );

  const handleClose = () => {
    setVerClientes(false);
  };

  const handleSearchTermChange = (value: string) => {
    setSearchTerm(value);
  };

  return {
    formatearNumeros,
    handleClose,
    handleSearchTermChange,
    isModalCreateClienteExistente,
    searchTerm,
    searchTermExis,
    setIsModalCreateClienteExistente,
    setSearchTermExis,
    sumaPagosDiarios,
  };
};
